import { Component, OnInit } from '@angular/core';
import * as $ from 'jquery';
import { Router } from '@angular/router';
import { AutenticationService } from '../../../shared/service/autentication/autentication.service';
import { RoleShortForm } from 'src/app/shared/interface/session-user.interface';
import { MasterDataManagementService } from 'src/app/shared/service/master-data-management/master-data-management.service';
import { FirebaseService } from '@service/firebase/firebase.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-dashboard-header',
  templateUrl: './dashboard-header.component.html',
  styleUrls: ['./dashboard-header.component.css'],
})
export class DashboardHeaderComponent implements OnInit {
  sessionUser: any;
  profileName: any;
  showCross: boolean = false;
  isProfilePopUpVisible: boolean = false;
  message: any = null;
  popupVisible_program: boolean;
  closeButtonOptions: { text: string; onClick(e: any): void };
  isAdmin: boolean;
  isPMO: boolean;
  isSMO: boolean;
  userInfo: any;
  unsubscribe$: Subject<boolean> = new Subject();
  notificationList: any[];
  
  constructor(
    public autenticationService: AutenticationService,
    public router: Router,
    public masterDataManagementService: MasterDataManagementService,
    public firebaseService: FirebaseService
  ) {
    const that = this;
    this.closeButtonOptions = {
      text: 'Close',
      onClick(e) {
        that.closeProgramPopUp(that);
      },
    };
  }

  ngOnInit(): void {
    this.backtoTop();
    this.theamColorChangeJS();
    this.sessionUser = this.autenticationService.getSessionUser();
    this.userInfo = this.autenticationService.getUserInfo();
    this.makeUserProfile();
    this.isAdmin = this.autenticationService.isAdminRole();
    this.isPMO = this.autenticationService.isRole(RoleShortForm.PMO);
    this.isSMO = this.autenticationService.isRole(RoleShortForm.SMO);
    if ((this.isPMO || this.isSMO) && this.userInfo) {
      const cohorts = this.userInfo?.program_cohort?.length
        ? this.userInfo?.program_cohort.map((cohort) => cohort.cohort_id).join()
        : null;
      this.getZonesByUserIDAndCohorts(this.userInfo.id, cohorts);
    }

      this.firebaseService
          .getNotificationListLoad()
          .pipe(takeUntil(this.unsubscribe$))
          .subscribe((result) => {
            if (result) {
              //console.log(result);
              this.notificationList = result;
              this.notificationList = this.notificationList.filter((n) => n.is_seen == false);
            }
          });
  }

  getZonesByUserIDAndCohorts(userID, cohortIDs) {
    if (cohortIDs) {
      this.masterDataManagementService
        .getWorkingAreasByUserAndCohorts(userID, cohortIDs)
        .subscribe(
          (result) => {
            if (result.status === 'ok') {
              const zones = [];
              result?.resultset?.forEach((data) => {
                const index = zones.findIndex(
                  (zone) =>
                    zone.zone_id === data.zone_id &&
                    zone.cohort_id === data.cohort_id
                );
                if (index === -1) {
                  zones.push(data);
                }
              });
              this.masterDataManagementService.allZonesByUserAndCohorts = zones;
            }
          },
          (err) => {
            console.log(err);
          }
        );
    } else {
      this.masterDataManagementService.allZonesByUserAndCohorts = [];
    }
  }

  makeUserProfile() {
    this.profileName = this.sessionUser.email.substring(0, 2);
    //console.log(this.profileName.toUpperCase());
    this.profileName = this.profileName.toUpperCase();
  }
  logout() {
    const res = this.autenticationService.logout();
    if (res) {
      this.autenticationService.setUserDataOnLocalStorageObs(false);
      //console.log('logout success');
      this.router.navigateByUrl('/auth');
    }
  }

  showProfile() {
    this.isProfilePopUpVisible = true;
  }

  showProgramPopUp() {
    this.popupVisible_program = true;
  }
  closeProgramPopUp(that?) {
    if (that) {
      that.popupVisible_program = false;
    } else {
      this.popupVisible_program = false;
    }
    // this.autenticationService.logout();
  }

  toggleSidebar() {
    var body = $('body');
    if (
      body.hasClass('sidebar-toggle-display') ||
      body.hasClass('sidebar-absolute')
    ) {
      body.toggleClass('sidebar-hidden');
      // this.showCross = false;
    } else {
      body.toggleClass('sidebar-icon-only');
      // this.showCross = true;
    }
    this.showCross = this.showCross == false ? true : false;
    body.toggleClass('toggleCustom');
    this.specialReportTableUIHandler();

    const mainPanel = document.getElementById('main-panel-control');
    if (this.showCross) {
      mainPanel.classList.add('sidebar-icon-only-main-panel-margin');
      mainPanel.classList.remove('sidebar-full-main-panel-margin');
    } else {
      mainPanel.classList.add('sidebar-full-main-panel-margin');
      mainPanel.classList.remove('sidebar-icon-only-main-panel-margin');
    }
  }

  theamColorChangeJS() {
    $(function () {
      $('.nav-settings').on('click', function () {
        $('#right-sidebar').toggleClass('open');
      });
      $('.settings-close').on('click', function () {
        $('#right-sidebar,#theme-settings').removeClass('open');
      });

      $('#settings-trigger').on('click', function () {
        $('#theme-settings').toggleClass('open');
      });

      $('[data-toggle="offcanvas"]').on('click', function () {
        $('.sidebar-offcanvas').toggleClass('active');
      });

      //background constants
      var navbar_classes =
        'navbar-danger navbar-success navbar-warning navbar-dark navbar-light navbar-primary navbar-info navbar-pink';
      var sidebar_classes = 'sidebar-light sidebar-dark';
      var $body = $('body');

      //sidebar backgrounds
      $('#sidebar-light-theme').on('click', function () {
        $body.removeClass(sidebar_classes);
        $body.addClass('sidebar-light');
        $('.sidebar-bg-options').removeClass('selected');
        $(this).addClass('selected');
      });
      $('#sidebar-dark-theme').on('click', function () {
        $body.removeClass(sidebar_classes);
        $body.addClass('sidebar-dark');
        $('.sidebar-bg-options').removeClass('selected');
        $(this).addClass('selected');
      });

      //Navbar Backgrounds
      $('.tiles.primary').on('click', function () {
        $('.navbar').removeClass(navbar_classes);
        $('.navbar').addClass('navbar-primary');
        $('.tiles').removeClass('selected');
        $(this).addClass('selected');
      });
      $('.tiles.success').on('click', function () {
        $('.navbar').removeClass(navbar_classes);
        $('.navbar').addClass('navbar-success');
        $('.tiles').removeClass('selected');
        $(this).addClass('selected');
      });
      $('.tiles.warning').on('click', function () {
        $('.navbar').removeClass(navbar_classes);
        $('.navbar').addClass('navbar-warning');
        $('.tiles').removeClass('selected');
        $(this).addClass('selected');
      });
      $('.tiles.danger').on('click', function () {
        $('.navbar').removeClass(navbar_classes);
        $('.navbar').addClass('navbar-danger');
        $('.tiles').removeClass('selected');
        $(this).addClass('selected');
      });
      $('.tiles.light').on('click', function () {
        $('.navbar').removeClass(navbar_classes);
        $('.navbar').addClass('navbar-light');
        $('.tiles').removeClass('selected');
        $(this).addClass('selected');
      });
      $('.tiles.info').on('click', function () {
        $('.navbar').removeClass(navbar_classes);
        $('.navbar').addClass('navbar-info');
        $('.tiles').removeClass('selected');
        $(this).addClass('selected');
      });
      $('.tiles.dark').on('click', function () {
        $('.navbar').removeClass(navbar_classes);
        $('.navbar').addClass('navbar-dark');
        $('.tiles').removeClass('selected');
        $(this).addClass('selected');
      });
      $('.tiles.default').on('click', function () {
        $('.navbar').removeClass(navbar_classes);
        $('.tiles').removeClass('selected');
        $(this).addClass('selected');
      });
    });
  }

  changePassword() {
    this.router.navigateByUrl('/dashboard/change-password');
  }

  specialReportTableUIHandler() {
    const specialReportHeaderId = document.getElementById(
      'specialReportHeaderId'
    );
    if (!!specialReportHeaderId && this.showCross) {
      specialReportHeaderId.style.setProperty('width', '0px');
    }
    if (!!specialReportHeaderId && !this.showCross) {
      specialReportHeaderId.style.removeProperty('width');
    }
  }

  backtoTop(){
    $(function () {

      var btn = $('#backToTopBtn');

      $(window).scroll(function() {
        if ($(window).scrollTop() > 300) {
          btn.addClass('show');
        } else {
          btn.removeClass('show');
        }
      });

      btn.on('click', function(e) {
        e.preventDefault();
        $('html, body').animate({scrollTop:0}, '300');
      });
    })
  }
}
